module.exports = __webpack_public_path__ + "static/media/3.f841ac2b.gif";